// Central site / company configuration — single source of truth.
export const SITE = {
  url: "https://demarmuhendislik.com.tr",
  name: "DEMAR Mühendislik",
  shortName: "DEMAR",
  phone: "+90 553 987 87 25",
  phoneRaw: "905539878725",
  email: "bilgi@demarmuhendislik.com.tr",
  emailAlt: "rufaidemir@yaani.com",
  addressLine: "Fulya, Büyükdere Cd. Lale İş Merkezi No: 62/31, 34349 Şişli / İstanbul",
  geo: { lat: 41.0631, lng: 28.9945 },
  social: {
    linkedin: "https://linkedin.com",
    instagram: "https://instagram.com",
    youtube: "https://youtube.com",
  },
  whatsapp: "https://wa.me/905539878725",
  founded: "2010",
  logo: "/img/logo.png",
};

export const NAV = [
  { to: "/", key: "home" },
  { to: "/hizmetler", key: "services" },
  { to: "/yazilimlar", key: "software" },
  { to: "/blog", key: "blog" },
  { to: "/tanitim", key: "brochure" },
  { to: "/iletisim", key: "contact" },
];
